// extracted by mini-css-extract-plugin
export default {"faqGroup":"FaqPage_faqGroup__KsfG-","categoryTitle":"FaqPage_categoryTitle__7kNW7","accordionContainer":"FaqPage_accordionContainer__6cNV+"};